import { ROUTES } from '@core/routes'

export const isUntrackedPage = (pathname: string): boolean => pathname === ROUTES.authCallback
